import React from 'react';
import { Card } from 'seagull';
import { TimeActivityDetails } from "./TimeActivityDetails/TimeActivityDetails";
import { AddTimeActivityButton } from "./AddTimeActivity";
import { TimeActivityExternalLink } from "./TimeActivityExternalLink";
import styles from "./TimeActivityCard.module.scss";
export const TimeActivityCard = _ref => {
  let {
    timeActivity
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, {
    key: timeActivity.id,
    "data-testid": "time-activity-".concat(timeActivity.id),
    className: styles.card
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(TimeActivityDetails, {
    timeActivity: timeActivity
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(TimeActivityExternalLink, {
    timeActivity: timeActivity
  }), /*#__PURE__*/React.createElement(AddTimeActivityButton, {
    timeActivity: timeActivity
  }))));
};